<template>
  <el-table v-loading="isLoading"
            :data="lista"
            border
            :stripe="true"
            style="width: 100%" header-row-class-name="table-progress">
    <el-table-column
      prop="id"
      label="#" :width="60">
    </el-table-column>
    <el-table-column
      prop="nome"
      label="Centro de Custo">
    </el-table-column>
    <el-table-column
      prop="user_name"
      label="Usuário">
    </el-table-column>
    <el-table-column
      prop="progresso"
      label="Progresso" >
      <template slot-scope="scope">
        <el-progress :percentage="scope.row.progresso"
                     :status="scope.row.progresso>= 100 ? 'success' : 'exception'"></el-progress>
      </template>
    </el-table-column>
    <el-table-column
      label="#"
      width="200">
      <template slot-scope="scope">
        <el-tooltip content="Responder" placement="top">
          <el-button type="danger" icon="el-icon-edit" size="small" class="pull-right ml-1"
                     @click="selectCentro(scope.row.id)">
          </el-button>
        </el-tooltip>
        <el-tooltip content="Download template com as respostas" placement="top">
          <el-button @click="linkToTemplate(scope.row)" type="success" icon="el-icon-download" size="small"
                     class="pull-right ml-1">
          </el-button>
        </el-tooltip>
        <el-tooltip content="Upload template com as respostas" placement="top">

          <el-upload
            :on-progress="onProgress"
            :on-success="onSuccess"
            class="pull-right"
            :action="uriUpload"
            :headers="headersUpload"
            name="respostas"
          >
            <el-button size="small" type="primary" icon="el-icon-upload" alt="upload"></el-button>
          </el-upload>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import FileSaver from 'file-saver'
  import slugify from 'slugify'
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "progress-list",
    props: ['lista', 'selected'],
    data() {
      return {
        isLoading: false,
        fileList: []
      }
    },
    computed: {
      ...mapState('Auth', ['access_token']),
      uriUpload() {
        return `${process.env.API_URI_PATH}/resposta/upload`
      },
      headersUpload() {
        return {
          Authorization: `Bearer ${this.access_token}`
        }
      }
    },
    methods: {
      ...mapActions('Seeder', ['shouldReload']),
      selectCentro(id) {
        this.$emit('update:selected', id)
      },
      async onSuccess() {
        this.shouldReload()
      }, async onProgress() {
        console.log('progress')
      },
      async linkToTemplate(centro) {
        this.isLoading = true
        try {
          const {data} = await axios.get(`${process.env.API_URI_PATH}/resposta/centrocusto/${centro.id}/template`, {responseType: 'blob'})
          const file = new Blob([data], {type: "application/vnd.openxmlformats-olefficedocument.spreadsheetml.sheet;charset=utf-8"});
          FileSaver.saveAs(file, `${slugify(centro.user_name, '_')}_${slugify(centro.nome, '_')}.xlsx`);
        } catch (e) {

        } finally {
          this.isLoading = false
        }

      }
    }
  }
</script>

<style>
  .table-progress th {
    background-color: #3F729B !important;
    color: #fff;

  }
  .table-progress {
    -moz-box-shadow:    inset 0 0 10px #000000;
    -webkit-box-shadow: inset 0 0 10px #000000;
    box-shadow:         inset 0 0 10px #000000;
  }
</style>



// WEBPACK FOOTER //
// src/features/Seeder/ProgressList.vue